<template>
  <div>
    <Bar
      :chart-options="chartOptions"
      :chart-data="chartData"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'
import { utils } from '@/helpers';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import ChartJSPluginDatalabels from "chartjs-plugin-datalabels";
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale,LinearScale, ChartJSPluginDatalabels )


export default {
  components: { Bar },
  props: {
    data: {},
    titulo: {
      type: String, 
      default: ''
    },
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Object,
      default: () => {}
    }
  },
  data(){
    return {
      chartData: {
        labels: this.data != null ? this.descCategoria(this.data.categoria) : [],
        datasets: this.data != null ? this.formatearData(this.data.data) : []
      },
      chartOptions: {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: this.titulo == '' ? 'Grafico de ejemplo': this.titulo
          },
          datalabels: {
            backgroundColor: function(context) {
              return context.dataset.backgroundColor;
            },
            borderColor: 'white',
            borderRadius: 25,
            borderWidth: 2,
            color: 'white',
            font: {
              weight: 'bold'
            },
          }
        }
      }
    }
  },
  watch:{
    data(){
      this.chartData = {
        labels: this.data != null ? this.descCategoria(this.data.categoria) : [],
        datasets: this.data != null ? this.formatearData(this.data.data) : []
      }
    },
    titulo(){
      this.chartOptions.plugins.title.text = this.titulo == '' ? 'Grafico de ejemplo': this.titulo;
    }
  },
  methods: {
    formatearData(data){
      data.forEach((element,i )=>{
        element.label = element.name;
        let colores = utils.coloresGraficos();

        element.backgroundColor = colores[i];

      });
      return data;
    },
    descCategoria(categoria){
      if(categoria == null){
        return categoria;
      }
      return categoria.map((element) => {
        if(element.length > 30){
          return element = element.slice(0,30) + ' ...';
        }else{
          return element;
        }
      });
    }
  }
}
</script>

<style scoped>
</style>
